import React from "react";
import InvoiceField from "../component/InvoiceFiled";

const FreelancerForm = ({ data = {}, onUpdate = () => {} }) => {

  const items = Array.isArray(data.items) ? data.items : [];

  const updateItem = (index, key, value) => {
    const updated = [...items];
    updated[index] = { ...updated[index], [key]: value };
    onUpdate("items", updated);
  };

  const addItem = () => {
    onUpdate("items", [...items, { desc: "", unitCost: "", qty: "" }]);
  };

  const removeItem = (index) => {
    const updated = items.filter((_, i) => i !== index);
    onUpdate("items", updated);
  };

  return (
    <div className="space-y-6">

      <h3 className="font-bold text-lg text-green-600 border-b pb-2">Freelancer Profile</h3>

      <InvoiceField 
        label="Company / Freelancer Name" 
        value={data.companyName || ""} 
        onChange={(v) => onUpdate("companyName", v)} 
      />

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField 
          label="Invoice Number" 
          value={data.invoiceNumber || ""} 
          onChange={(v) => onUpdate("invoiceNumber", v)} 
        />
        <InvoiceField 
          label="Invoice Date" 
          type="date" 
          value={data.date || ""} 
          onChange={(v) => onUpdate("date", v)} 
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField 
          label="Customer ID" 
          value={data.customerId || ""} 
          onChange={(v) => onUpdate("customerId", v)} 
        />
        <InvoiceField 
          label="P.O. Number" 
          type="number" 
          value={data.poNumber || ""} 
          onChange={(v) => onUpdate("poNumber", v)} 
        />
      </div>

      <h4 className="font-semibold text-sm text-gray-500 border-b pb-1">Company Details</h4>

      <InvoiceField 
        label="Address" 
        type="description" 
        rows="2"
        value={data?.companyDetails?.address || ""} 
        onChange={(v) => onUpdate("companyDetails", { ...data.companyDetails, address: v })} 
      />

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField 
          label="City / State" 
          value={data?.companyDetails?.city || ""} 
          onChange={(v) => onUpdate("companyDetails", { ...data.companyDetails, city: v })} 
        />
        <InvoiceField 
          label="Pincode" 
          type="number"
          value={data?.companyDetails?.pincode || ""} 
          onChange={(v) => onUpdate("companyDetails", { ...data.companyDetails, pincode: v })} 
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField 
          label="Phone" 
          type="number"
          value={data?.companyDetails?.phone || ""} 
          onChange={(v) => onUpdate("companyDetails", { ...data.companyDetails, phone: v })} 
        />
        <InvoiceField 
          label="Email" 
          value={data?.companyDetails?.email || ""} 
          onChange={(v) => onUpdate("companyDetails", { ...data.companyDetails, email: v })} 
        />
      </div>

      <InvoiceField 
        label="Website" 
        value={data?.companyDetails?.website || ""} 
        onChange={(v) => onUpdate("companyDetails", { ...data.companyDetails, website: v })} 
      />

      <h4 className="font-semibold text-sm text-gray-500 border-b pb-1">Client Details</h4>

      <InvoiceField 
        label="Client Name" 
        value={data?.client?.name || ""} 
        onChange={(v) => onUpdate("client", { ...data.client, name: v })} 
      />

      <InvoiceField 
        label="Client Address" 
        type="description" 
        rows="2"
        value={data?.client?.address || ""} 
        onChange={(v) => onUpdate("client", { ...data.client, address: v })} 
      />

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField 
          label="City / State" 
          value={data?.client?.city || ""} 
          onChange={(v) => onUpdate("client", { ...data.client, city: v })} 
        />
        <InvoiceField 
          label="Pincode" 
          type="number"
          value={data?.client?.pincode || ""} 
          onChange={(v) => onUpdate("client", { ...data.client, pincode: v })} 
        />
      </div>

      <InvoiceField 
        label="Client Phone" 
        type="number"
        value={data?.client?.phone || ""} 
        onChange={(v) => onUpdate("client", { ...data.client, phone: v })} 
      />

      <h4 className="font-semibold text-sm text-gray-500 border-b pb-1">Invoice Items</h4>

      {items.map((item, index) => (
        <div key={index} className="border p-3 rounded-md space-y-2">
          <InvoiceField 
            label="Item Description" 
            value={item.desc || ""} 
            onChange={(v) => updateItem(index, "desc", v)} 
          />
          <div className="grid grid-cols-3 gap-3">
            <InvoiceField 
              label="Rate (₹)" 
              type="number" 
              value={item.unitCost || ""} 
              onChange={(v) => updateItem(index, "unitCost", v)} 
            />
            <InvoiceField 
              label="Quantity" 
              type="number" 
              value={item.qty || ""} 
              onChange={(v) => updateItem(index, "qty", v)} 
            />
            <div className="flex items-end">
              <button 
                type="button" 
                onClick={() => removeItem(index)} 
                className="w-full px-3 py-2 bg-red-500 text-white rounded-md"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      ))}

      <button 
        type="button" 
        onClick={addItem} 
        className="px-4 py-2 bg-green-600 text-white rounded-md"
      >
        Add Item
      </button>

      <h4 className="font-semibold text-sm text-gray-500 border-b pb-1">Billing Summary</h4>

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField 
          label="Discount (₹)" 
          type="number" 
          value={data.discount || ""} 
          onChange={(v) => onUpdate("discount", v)} 
        />
        <InvoiceField 
          label="GST (%)" 
          type="number" 
          value={data.taxRate || ""} 
          onChange={(v) => onUpdate("taxRate", v)} 
        />
      </div>

      <InvoiceField 
        label="Special Instructions" 
        type="description" 
        value={data.notes || ""} 
        onChange={(v) => onUpdate("notes", v)} 
        rows="2" 
      />

    </div>
  );
};

export default FreelancerForm;
